import TransactionTable from "./TransactionTable";
import TransactionPagination from "./TransactionPagination";
import TabButtons from "./TabButtons";
import SearchBar from "./SearchBar";
import ReportTitle from "./ReportTitle";
import ReportDownloadButtons from "./ReportDownloadButtons";
import DateFilterForm from "./DateFilterForm";
import BreadcrumbsComponent from "./BreadcrumbsComponent";
import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Grid } from "@material-ui/core";
import axios from "axios";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import Papa from "papaparse"; // Import PapaParse
import iPaisaLogo from "../../Assets/iPaisaLogo/iPaisaLogo.jpg";
import { makeStyles } from "@mui/styles";
import * as XLSX from "xlsx";

import { fetchDebitData, fetchCreditData, BASE_URL, generateCSV } from "./api";
import { toast, ToastContainer } from "react-toastify";

const useStyles = makeStyles(() => ({
  evenRow: {
    backgroundColor: "#D0EFFF",
  },
  oddRow: {
    backgroundColor: "#FFFFFF",
  },
}));
const NewFundTReport = () => {
  const [activeTab, setActiveTab] = useState("DEBIT");
  const [debitData, setDebitData] = useState([]);
  const [creditData, setCreditData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const userType = sessionStorage.getItem("uType");
  const userName = sessionStorage.getItem("username");
  const [totalCredits, setTotalCredits] = useState(0);
  const [totalDebits, setTotalDebits] = useState(0);
  const classes = useStyles();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [debitPage, setDebitPage] = useState(0);
  const [creaditPage, setCreditPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [downloadLoading, setDownloadLoading] = useState(false);

  // Format date to dd-mm-yyyy
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const fetchCreditDataHere = async (query, start, end, page, size) => {
    setLoading(true);
    const respone = await fetchCreditData(query, start, end, page, size);
    setCreditData(respone?.content || []);
    setTotalCredits(respone?.totalElements || 0);
    console.log(respone);
    setLoading(false);
    return respone;
  };

  const fetchDebitDatahere = async (query, start, end, page, size) => {
    setLoading(true);
    const respone = await fetchDebitData(query, start, end, page, size);
    console.log(respone);
    setDebitData(respone?.content || []);
    setTotalDebits(respone?.totalElements || 0);
    setLoading(false);
    return respone;
  };

  useEffect(() => {
    setLoading(true);
    // Get today's date in 'YYYY-MM-DD' format
    const today = new Date().toISOString().split("T")[0];
    setStartDate(today);
    setEndDate(today);
    setRowsPerPage(10);
    fetchCreditDataHere("", today, today, 0, 10);
    fetchDebitDatahere("", today, today, 0, 10);
  }, []);

  useEffect(() => {
    setLoading(true);
    if (activeTab === "DEBIT") {
      fetchDebitDatahere(searchQuery, startDate, endDate, 0, rowsPerPage);
    } else if (activeTab === "CREDIT") {
      fetchCreditDataHere(searchQuery, startDate, endDate, 0, rowsPerPage);
    }
  }, [activeTab, startDate, endDate]);

  // Handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    // setFilteredData(tab === "DEBIT" ? debitData : creditData);
    // setPage(0);
  };

  // Date search handler (from Formik)
  const handleSearch = (values) => {
    const { fromDate, toDate } = values;
    const from = new Date(fromDate).toISOString().split("T")[0];
    const to = new Date(toDate).toISOString().split("T")[0];
    setStartDate(from);
    setEndDate(to);
    if (activeTab === "DEBIT") {
      fetchDebitDatahere(searchQuery, from, to, 0, rowsPerPage);
    } else if (activeTab === "CREDIT") {
      fetchCreditDataHere(searchQuery, from, to, 0, rowsPerPage);
    }
    setDebitPage(0);
    setCreditPage(0);
  };

  // Clear the search and filters
  const handleClear = (resetForm) => {
    // resetForm();
    setSearchQuery("");
    // setFilteredData([...debitData, ...creditData]);
    // setActiveTab("DEBIT");
  };

  // Invoice download (PDF for individual transaction)
  const handleDownloadInvoice = async (data) => {
    const { invoiceId } = data;
    const receiptElement = document.getElementById(invoiceId);
    if (!receiptElement) {
      console.error("Receipt element not found:", `receipt-${data.senderId}`);
      return;
    }
    const opt = {
      margin: [0.5, 0.5, 0.5, 0.5],
      filename: `Fund Transfer Receipt-${data.senderId}_${data.tranxid}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        unit: "in",
        orientation: "landscape",
        format: "a4",
        margin: 0.5,
      },
    };

    try {
      await html2pdf().from(receiptElement).set(opt).save();
    } catch (error) {
      console.error("Error generating PDF: ", error);
    }
  };
  const exportDebitData = async (exportType) => {
    try {
      setDownloadLoading(true);
      const response = await axios.get(`${BASE_URL}/wtransReportDebttoexport`, {
        params: {
          startDate,
          endDate,
        },
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      });

      if (response.status === 200) {
        if (exportType === "pdf") {
          generateDebitPDF(response.data);
        } else if (exportType === "excel") {
          generateDebitExcel(response.data);
        } else if (exportType === "csv") {
          generateDebitCSV(response.data);
        }
      } else if (response.status === 204) {
        toast.warn("No data available for the selected date range");
      } else {
        toast.error("Something went wrong while downloading the report");
      }
    } catch (error) {
      console.error("Error exporting debit data:", error);
      toast.error("Failed to download the report");
    } finally {
      setDownloadLoading(false);
    }
  };

  const exportCreditData = async (exportType) => {
    try {
      setDownloadLoading(true);
      const response = await axios.get(`${BASE_URL}/wtransReportCredtoexport`, {
        params: {
          startDate,
          endDate,
        },
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      });

      if (response.status === 200) {
        if (exportType === "pdf") {
          generateCreditPDF(response.data);
        } else if (exportType === "excel") {
          generateCreditExcel(response.data);
        } else if (exportType === "csv") {
          generateCreditCSV(response.data);
        }
      } else if (response.status === 204) {
        toast.warn("No data available for the selected date range");
      } else {
        toast.error("Something went wrong while downloading the report");
      }
    } catch (error) {
      console.error("Error exporting credit data:", error);
      toast.error("Failed to download the report");
    } finally {
      setDownloadLoading(false);
    }
  };

  // PDF generation
  const generateDebitPDF = (data) => {
    const doc = new jsPDF("landscape");

    // Add header
    doc.addImage(iPaisaLogo, "PNG", 14, 10, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("Fund Transfer Report - DEBIT", 50, 25);

    // Add date range
    doc.setFontSize(12);
    doc.text(
      `Date Range: ${formatDate(startDate)} to ${formatDate(endDate)}`,
      50,
      35
    );

    const tableColumn = [
      "Sr. No.",
      "Date",
      "Transaction ID",
      "Sender Name",
      "Receiver Name",
      "Opening Balance",
      "Amount",
      "Closing Balance",
      "Type",
      "Remark",
    ];

    const tableRows = data.map((row, index) => [
      index + 1,
      formatDate(row.transaction.date),
      row.transaction.tranxid,
      row.transaction.senderName,
      row.transaction.reciverName,
      Number(row.transaction.wOpeningBalance).toFixed(2),
      Number(row.transaction.amount).toFixed(2),
      Number(row.transaction.wClosingBalance).toFixed(2),
      row.transaction.transactionType,
      row.transaction.remark || "N/A",
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [2, 123, 254],
        textColor: [255, 255, 255],
        fontSize: 9,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [240, 248, 255],
      },
    });

    const currentDateTime = new Date().toISOString().split("T")[0];
    doc.save(`fund_transfer_debit_${currentDateTime}.pdf`);
  };

  const generateCreditPDF = (data) => {
    const doc = new jsPDF("landscape");

    // Add header
    doc.addImage(iPaisaLogo, "PNG", 14, 10, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("Fund Transfer Report - CREDIT", 50, 25);

    // Add date range
    doc.setFontSize(12);
    doc.text(
      `Date Range: ${formatDate(startDate)} to ${formatDate(endDate)}`,
      50,
      35
    );

    const tableColumn = [
      "Sr. No.",
      "Date",
      "Transaction ID",
      "Sender Name",
      "Receiver Name",
      "Opening Balance",
      "Amount",
      "Closing Balance",
      "Type",
      "Remark",
    ];

    const tableRows = data.map((row, index) => [
      index + 1,
      formatDate(row.transaction.date),
      row.transaction.tranxid,
      row.transaction.senderName,
      row.transaction.reciverName,
      Number(row.transaction.wOpeningBalance).toFixed(2),
      Number(row.transaction.amount).toFixed(2),
      Number(row.transaction.wClosingBalance).toFixed(2),
      row.transaction.transactionType,
      row.transaction.remark || "N/A",
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [2, 123, 254],
        textColor: [255, 255, 255],
        fontSize: 9,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [240, 248, 255],
      },
    });

    const currentDateTime = new Date().toISOString().split("T")[0];
    doc.save(`fund_transfer_credit_${currentDateTime}.pdf`);
  };

  // Excel generation
  const generateDebitExcel = (data) => {
    const excelData = data.map((row, index) => ({
      "Sr. No.": index + 1,
      Date: formatDate(row.transaction.date),
      "Transaction ID": row.transaction.tranxid,
      "Sender Name": row.transaction.senderName,
      "Receiver Name": row.transaction.reciverName,
      "Opening Balance": Number(row.transaction.wOpeningBalance).toFixed(2),
      Amount: Number(row.transaction.amount),
      "Closing Balance": Number(row.transaction.wClosingBalance).toFixed(2),
      Type: row.transaction.transactionType,
      Remark: row.transaction.remark || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Debit Transactions");

    // Set column widths
    const columnWidths = [
      { wch: 8 }, // Sr. No.
      { wch: 20 }, // Date
      { wch: 15 }, // Transaction ID
      { wch: 20 }, // Sender Name
      { wch: 20 }, // Receiver Name
      { wch: 15 }, // Opening Balance
      { wch: 12 }, // Amount
      { wch: 15 }, // Closing Balance
      { wch: 12 }, // Type
      { wch: 30 }, // Remark
    ];
    worksheet["!cols"] = columnWidths;

    const currentDateTime = new Date().toISOString().split("T")[0];
    XLSX.writeFile(workbook, `fund_transfer_debit_${currentDateTime}.xlsx`);
  };

  const generateCreditExcel = (data) => {
    const excelData = data.map((row, index) => ({
      "Sr. No.": index + 1,
      Date: formatDate(row.transaction.date),
      "Transaction ID": row.transaction.tranxid,
      "Sender Name": row.transaction.senderName,
      "Receiver Name": row.transaction.reciverName,
      "Opening Balance": Number(row.transaction.wOpeningBalance).toFixed(2),
      Amount: Number(row.transaction.amount),
      "Closing Balance": Number(row.transaction.wClosingBalance).toFixed(2),
      Type: row.transaction.transactionType,
      Remark: row.transaction.remark || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Credit Transactions");

    // Set column widths
    const columnWidths = [
      { wch: 8 }, // Sr. No.
      { wch: 20 }, // Date
      { wch: 15 }, // Transaction ID
      { wch: 20 }, // Sender Name
      { wch: 20 }, // Receiver Name
      { wch: 15 }, // Opening Balance
      { wch: 12 }, // Amount
      { wch: 15 }, // Closing Balance
      { wch: 12 }, // Type
      { wch: 30 }, // Remark
    ];
    worksheet["!cols"] = columnWidths;

    const currentDateTime = new Date().toISOString().split("T")[0];
    XLSX.writeFile(workbook, `fund_transfer_credit_${currentDateTime}.xlsx`);
  };

  // CSV generation
  const generateDebitCSV = (data) => {
    const csvData = data.map((row, index) => ({
      "Sr. No.": index + 1,
      "Transaction ID": row.transaction.tranxid,
      "Sender ID": row.transaction.senderId,
      "Sender Name": row.transaction.senderName,
      "Receiver ID": row.transaction.reciverId,
      "Receiver Name": row.transaction.reciverName,
      Date: new Date(row.transaction.date).toLocaleString(),
      "Wallet Opening Balance": row.transaction.wOpeningBalance.toFixed(2),
      Amount: Number(row.transaction.amount),
      "Wallet Closing Balance": row.transaction.wClosingBalance.toFixed(2),
      Remark: row.transaction.remark,
      "Transaction Type": row.transaction.transactionType,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "DEBIT_Transaction_Statement.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const generateCreditCSV = (data) => {
    const csvData = data.map((row, index) => ({
      "Sr. No.": index + 1,
      "Transaction ID": row.transaction.tranxid,
      "Sender ID": row.transaction.senderId,
      "Sender Name": row.transaction.senderName,
      "Receiver ID": row.transaction.reciverId,
      "Receiver Name": row.transaction.reciverName,
      Date: new Date(row.transaction.date).toLocaleString(),
      "Wallet Opening Balance": Number(row.transaction.wOpeningBalance).toFixed(
        2
      ),
      Amount: Number(row.transaction.amount),
      "Wallet Closing Balance": Number(row.transaction.wClosingBalance).toFixed(
        2
      ),
      Remark: row.transaction.remark,
      "Transaction Type": row.transaction.transactionType,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "CREDIT_Transaction_Statement.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // Download handlers
  const handleDownloadPDF = () => {
    if (activeTab === "DEBIT") {
      exportDebitData("pdf");
    } else {
      exportCreditData("pdf");
    }
  };

  const handleDownloadExcel = () => {
    if (activeTab === "DEBIT") {
      exportDebitData("excel");
    } else {
      exportCreditData("excel");
    }
  };

  const handleDownloadCSV = () => {
    if (activeTab === "DEBIT") {
      exportDebitData("csv");
    } else {
      exportCreditData("csv");
    }
  };

  // Search input change handler
  const handleSearchInput = (event) => {
    setSearchQuery(event.target.value);
  };

  // Search button click handler (calls API search)
  const handleSearchButtonClick = async () => {
    if (activeTab === "DEBIT") {
      setDebitPage(0);
      fetchDebitDatahere(searchQuery, startDate, endDate, 0, rowsPerPage);
    } else if (activeTab === "CREDIT") {
      setCreditPage(0);
      fetchCreditDataHere(searchQuery, startDate, endDate, 0, rowsPerPage);
    }
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    console.log(activeTab);
    if (activeTab === "DEBIT") {
      setDebitPage(newPage);
      fetchDebitDatahere(searchQuery, startDate, endDate, newPage, rowsPerPage);
    } else if (activeTab === "CREDIT") {
      setCreditPage(newPage);
      fetchCreditDataHere(
        searchQuery,
        startDate,
        endDate,
        newPage,
        rowsPerPage
      );
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setDebitPage(0);
    setCreditPage(0);

    if (activeTab === "DEBIT") {
      fetchDebitDatahere(searchQuery, startDate, endDate, 0, newRowsPerPage);
    } else if (activeTab === "CREDIT") {
      fetchCreditDataHere(searchQuery, startDate, endDate, 0, newRowsPerPage);
    }
  };

  return (
    <Box style={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}>
      <BreadcrumbsComponent />
      <Grid container spacing={2} sx={{ marginTop: "1%" }}>
        <Grid item xs={12} md={6}>
          <ReportTitle />
        </Grid>
        <ReportDownloadButtons
          onDownloadCSV={() =>
            activeTab === "DEBIT"
              ? exportDebitData("csv")
              : exportCreditData("csv")
          }
          onDownloadPDF={() =>
            activeTab === "DEBIT"
              ? exportDebitData("pdf")
              : exportCreditData("pdf")
          }
          onDownloadExcel={() =>
            activeTab === "DEBIT"
              ? exportDebitData("excel")
              : exportCreditData("excel")
          }
          loading={downloadLoading}
          activeTab={activeTab}
        />
      </Grid>
      <DateFilterForm
        startDate={startDate}
        endDate={endDate}
        onSearch={handleSearch}
        onClear={handleClear}
      />

      {loading && (
        <Typography variant="h6" sx={{ textAlign: "center", mt: 2 }}>
          Loading...
        </Typography>
      )}
      {error && (
        <Typography color="error" sx={{ textAlign: "center", mt: 2 }}>
          {error}
        </Typography>
      )}
      {!loading && !error && (
        <>
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "2%",
            }}
          >
            {(userType === "ADMIN" || userType === "SUBADMIN") && (
              <SearchBar
                searchQuery={searchQuery}
                onSearchInput={handleSearchInput}
                onSearchButtonClick={handleSearchButtonClick}
              />
            )}

            <TabButtons
              userType={userType}
              activeTab={activeTab}
              onTabClick={handleTabClick}
            />
          </Grid>

          <TransactionTable
            data={activeTab === "DEBIT" ? debitData : creditData}
            activeTab={activeTab}
            page={activeTab === "DEBIT" ? debitPage : creaditPage}
            rowsPerPage={rowsPerPage}
            handleDownloadInvoice={handleDownloadInvoice}
            formatDate={formatDate}
            classes={classes}
            key={`${activeTab}-${activeTab === "DEBIT" ? debitPage + 1 : creaditPage + 1}`} // Forces re-render
          />

          <TransactionPagination
            count={activeTab === "DEBIT" ? totalDebits : totalCredits}
            page={activeTab === "DEBIT" ? debitPage : creaditPage}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="colored"
      />
    </Box>
  );
};

export default NewFundTReport;
